// export default (): {
//   sponsors: API.Service.Sponsor[] | undefined;
//   sponsorsLoading: boolean;
//   refreshSponsors: () => void;
//   fetchRewardsMap:
//     | Record<string, () => Promise<API.Service.SponsorDefinition[]>>
//     | undefined;
//   rewardsMap: Map<string, API.Service.SponsorDefinition[]>;
//   getRewardsMap: (
//     sponsorId: string,
//   ) => API.Service.SponsorDefinition[] | undefined;
//   itemsLoading: boolean;
//   allSponsorDefinitionItems: API.Service.SponsorDefinition[];
// } => {
//   const { ready } = useModel('@@initialState', (model) => ({
//     ready:
//       !!model.initialState?.currentUser &&
//       model.initialState?.currentUser?.authority ===
//         UserAuthority.ADMINISTRATOR,
//     //currentUser: model.initialState?.currentUser,
//   }));

import { UserAuthority } from '@/constants';
import sponsorService from '@/services/sponsorService';
import { useModel, useRequest } from '@umijs/max';

//   const {
//     data: sponsors,
//     loading: sponsorsLoading,
//     refresh: refreshSponsors,
//   } = useRequest<API.Service.Sponsor[]>(sponsorService.getSponsors, {
//     ready,
//   });

//   const [
//     rewardsMap,
//     {
//       set: setRewardsMap,
//       setAll: setAllRewardsMap,
//       //remove: removeRewardsMap,
//       get: getRewardsMap,
//     },
//   ] = useMap<string, API.Service.SponsorDefinition[]>([]);

//   const [itemsLoading, setItemsLoading] = useState<boolean>(false);

//   const allSponsorDefinitionItems = useMemo(() => {
//     return Array.from(rewardsMap?.values() || []).flat();
//   }, [rewardsMap]);

//   useAsyncEffect(async () => {
//     if (!sponsors) return;
//     setItemsLoading(true);
//     try {
//       const definitions = await Promise.all(
//         sponsors.map(async (sponsor) => {
//           return {
//             sponsorId: sponsor.id,
//             definition:
//               sponsor.status === SponsorStatus.ACTIVE
//                 ? (
//                     await sponsorService.getSponsorDefinition({
//                       id: sponsor.id,
//                     })
//                   ).map((definition) => {
//                     return {
//                       ...definition,
//                       sponsor: sponsor,
//                     };
//                   })
//                 : [],
//           };
//         }),
//       );

//       setAllRewardsMap(
//         definitions.map((item) => [item.sponsorId, item.definition]),
//       );
//     } catch (error) {
//       console.error('get items error', error);
//     } finally {
//       setItemsLoading(false);
//     }
//   }, [sponsors]);

//   const fetchRewardsMap = useMemo(() => {
//     return sponsors
//       ?.filter((sponsor) => sponsor.status === SponsorStatus.ACTIVE)
//       .reduce((acc, sponsor) => {
//         acc[sponsor.id] = async () => {
//           const response = await sponsorService.getSponsorDefinition({
//             id: sponsor.id,
//           });
//           setRewardsMap(sponsor.id, response);
//           return response;
//         };
//         return acc;
//       }, {} as Record<string, () => Promise<API.Service.SponsorDefinition[]>>);
//   }, [sponsors]);

//   // const sponsorsWithItems = useMemo(() => {
//   //   return sponsors?.map((sponsor) => {
//   //     return {
//   //       ...sponsor,
//   //       items: allSponsorDefinitionItems.filter(
//   //         (item) => item.sponsorId === sponsor.id,
//   //       ),
//   //     };
//   //   });
//   // }, [sponsors, allSponsorDefinitionItems]);

//   return {
//     sponsors,
//     sponsorsLoading,
//     refreshSponsors,
//     fetchRewardsMap,
//     rewardsMap,
//     getRewardsMap,
//     itemsLoading,
//     allSponsorDefinitionItems,
//   };
// };

export default (): {
  sponsors: API.Service.Sponsor[];
  sponsorsLoading: boolean;
  refreshSponsors: () => void;
} => {
  const { ready } = useModel('@@initialState', (model) => ({
    ready:
      !!model.initialState?.currentUser &&
      model.initialState?.currentUser?.authority ===
        UserAuthority.ADMINISTRATOR,
    //currentUser: model.initialState?.currentUser,
  }));

  const {
    data: sponsors,
    loading: sponsorsLoading,
    refresh: refreshSponsors,
  } = useRequest(sponsorService.getSponsors, {
    ready,
  });

  return {
    sponsors: sponsors || [],
    sponsorsLoading,
    refreshSponsors,
  };
};
